import { PUBLIC_SETTINGS, RESET } from '../actions/Events';

export default function (state = { loading: false }, action) {
  switch (action.type) {
    case PUBLIC_SETTINGS:
      return { ...state, settings: action.payload }

    case RESET:
      return { ...state, currentModule: null }

    default:
      return state
  }
}

